import { useSegment } from "tracking"
import React, { useEffect, useRef } from "react"
import type { AvailabilityEnum, VariantType } from "types"
import { Button } from "../../../ui-shared/components/Button/Button"
import { useProductCard } from "../../hooks/useProductCard"

export const ProductCardButton: React.FC = () => {
  const {
    productCardData,
    addToBasket,
    setIsShadeSelectorOpen,
    setConfirmationVariant,
    setConfirmation,
  } = useProductCard()

  const {
    brandName = "",
    productName = "",
    variationName = "",
  } = productCardData
  const { track } = useSegment()

  const clickedProductToVariantType: VariantType = {
    sku: productCardData.sku,
    pricing: {
      members: productCardData.primaryPriceRaw,
      typical: productCardData.secondaryPriceRaw,
      guest: productCardData.primaryPriceRaw,
    },
    availability: {
      status:
        productCardData.inStock === true
          ? ("inStock" as AvailabilityEnum)
          : ("outOfStock" as AvailabilityEnum),
      stockCount: productCardData.inStock === true ? 999999 : 0,
    },
    brandName: productCardData?.brandName ?? "",
    title: productCardData?.productName,
    stockLimit: productCardData.inStock === true ? 999999 : 0,
    visuals: [],
    detailsMedia: {
      id: productCardData.sku,
      src: productCardData.image.src,
    },
  }

  const buttonRef = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.dataset.testRenderState = "complete"
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCardData.buttonText])

  return (
    <Button
      buttonRef={buttonRef}
      variant="primary"
      disabled={productCardData.isPrimaryButtonDisabled}
      handleClick={async (event) => {
        event?.preventDefault()
        if (productCardData.swatchImages?.length) {
          track({
            event: "Page Element Clicked",
            properties: {
              module_content: "Open Shade Selector",
              module_content_details: `PLP Select Shade Button: ${brandName} ${productName} ${variationName}`,
            },
          })
          setIsShadeSelectorOpen?.(true)
        } else {
          await addToBasket()
          setConfirmation?.(true)
          setConfirmationVariant?.(clickedProductToVariantType)
        }
      }}
      fullWidth
    >
      {productCardData.buttonText}
    </Button>
  )
}
